import { createLogger } from "../../utils";
const logger = createLogger("Placements");
function isExtension(section) {
    return typeof section.source !== "undefined";
}
function extendSection(section, extension) {
    let placements = [];
    // Start with source placements...
    placements = [...section];
    // Remove if required
    if (extension.remove &&
        Array.isArray(extension.remove) &&
        extension.remove.length > 0) {
        logger.logInfo(`Removing ${extension.remove?.length} placements from source`);
        placements = [
            ...placements.filter((p) => !extension.remove?.includes(p.divId)),
        ];
    }
    // Add as needed
    if (extension.add &&
        Array.isArray(extension.add) &&
        extension.add.length > 0) {
        logger.logInfo(`Extending section with ${extension.add?.length} placements`);
        placements = [...placements, ...extension.add];
    }
    return placements;
}
function getPlacementsForSection(placementsConfig, section) {
    let placements = [];
    logger.logInfo(`Starting placement setup for section ${section}`);
    if (placementsConfig[section]) {
        const placementsSection = placementsConfig[section];
        if (isExtension(placementsSection)) {
            logger.logInfo(`Section ${section} is an extension`);
            const sourceSection = placementsConfig[placementsSection.source];
            if (!isExtension(sourceSection)) {
                logger.logInfo(`Extension for section ${section} seems valid`);
                placements = extendSection(sourceSection, placementsSection);
            }
            else {
                logger.logError(`Source section ${section} is not a valid section to extend from`);
            }
        }
        else {
            logger.logInfo(`Section ${section} is not extension, use as is
      `);
            placements = placementsSection;
        }
    }
    else {
        logger.logError(`Placements configuration for ${section} does not exist`);
    }
    return placements;
}
export default getPlacementsForSection;
//# sourceMappingURL=placements.js.map